// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"79ee44df","781":"0cb598f0"}[chunkId] + ".chunk.css";
};